<kendo-tabstrip #tabs>
    <kendo-tabstrip-tab [title]="'Items'" [selected]="this.profileService.selectedIndex === 0">
        <ng-template kendoTabContent>
            <app-profile-items [powerUserName]="powerUserName"
                    *ngIf='this.profileService.profileItem !== undefined && profileCategoriesService.initialized'>
            </app-profile-items>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="hide" [title]="'Categories'" [selected]="this.profileService.selectedIndex === 1">
        <ng-template kendoTabContent>
            <app-profile-categories
                    *ngIf='this.profileService.profileItem !== undefined && profileCategoriesService.initialized'></app-profile-categories>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
<div kendoDialogContainer></div>
